// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"invite_title__3DSmT","edit-border":"invite_edit-border__DAutR","invite-button":"invite_invite-button__1-Orl"};